import React from 'react';

import { mapIndexed } from 'utils/ramdaAdditions';

const LanguagesField = ({ list }) => list && list.length ? (
    <div>
        { mapIndexed((lang, index) => (
            <div key={index}>
                <span>{lang.name}</span>
                { lang.level && <span> ({lang.level})</span> }
            </div>
        ), list)}
    </div>
) : null;

export default LanguagesField;
